import React, { useEffect } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { Message, Container, Header } from 'semantic-ui-react';

// This component replaces the original signup form with a redirect to login
// It maintains backward compatibility for any external links to the signup page
export default function SignupForm() {
  const { client } = useParams();
  const history = useHistory();

  // Redirect to login after a short delay
  useEffect(() => {
    const timer = setTimeout(() => {
      // Redirect to login page, preserving the client parameter if present
      const redirectPath = client ? `/login/${client}` : '/login';
      history.replace(redirectPath);
    }, 3000); // 3 second delay before redirect

    return () => clearTimeout(timer);
  }, [history, client]);

  return (
    <Container text style={{ marginTop: '5em', textAlign: 'center' }}>
      <Header as="h2">Sign-up Page Moved</Header>
      <Message info>
        <Message.Header>
          Sign-up is now available through the admin panel
        </Message.Header>
        <p>
          For security reasons, account creation has been moved to the
          admin panel. You will be redirected to the login page
          shortly.
        </p>
        <p>
          If you need an account, please contact your administrator.
        </p>
      </Message>
    </Container>
  );
}
